import React from 'react';
import {
  AuthenticationLayout,
  AuthenticationLayoutForm,
  BackToEmailStepButton,
  VerifyIdentityButton,
} from 'Views/Authentication/Components';
import useMetaLayoutContext
  from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes
  from 'prop-types';

export const AuthnMfaRequiredResetStepLayout = ({ setAuthCollection }) => {
  const { resource } = useMetaLayoutContext();

  return (
    <AuthenticationLayout>
      <AuthenticationLayoutForm
        id={'mfa-required-reset'}
        onSubmit={() => {}}
        errors={[]}
      >
        <BackToEmailStepButton resource={resource} setAuthCollection={setAuthCollection} />
        <VerifyIdentityButton />
      </AuthenticationLayoutForm>
    </AuthenticationLayout>
  );
};

AuthnMfaRequiredResetStepLayout.propTypes = {
  setAuthCollection: PropTypes.func.isRequired,
};
